// ── Shared Data & Constants ───────────────────────────────────────────────────

export const SUBSCRIBERS = [
  { id: 1,  name: "Sunita Ramesh",   phone: "9841012345", email: "sunita@email.com",   plan: "Weekly",  type: "Veg",     persons: 2, amount: 2800,  status: "Active",  startDate: "2026-01-10", nextRenewal: "2026-03-22", deliveryArea: "Anna Nagar",    notes: "No onion, no garlic" },
  { id: 2,  name: "Arjun Kumar",     phone: "9962034567", email: "arjun@email.com",    plan: "Monthly", type: "Non-Veg", persons: 4, amount: 9600,  status: "Active",  startDate: "2025-12-01", nextRenewal: "2026-04-01", deliveryArea: "T Nagar",        notes: "" },
  { id: 3,  name: "Priya Mehta",     phone: "8056012398", email: "priya@email.com",    plan: "Weekly",  type: "Jain",    persons: 1, amount: 1400,  status: "Pending", startDate: "2026-03-01", nextRenewal: "2026-03-22", deliveryArea: "Velachery",      notes: "No root vegetables" },
  { id: 4,  name: "Ravi Nair",       phone: "9443098765", email: "ravi@email.com",     plan: "Monthly", type: "Vegan",   persons: 2, amount: 6200,  status: "Overdue", startDate: "2026-02-01", nextRenewal: "2026-03-01", deliveryArea: "Adyar",          notes: "" },
  { id: 5,  name: "Deepa Varma",     phone: "9884056712", email: "deepa@email.com",    plan: "Weekly",  type: "Veg",     persons: 3, amount: 3900,  status: "Active",  startDate: "2026-01-20", nextRenewal: "2026-03-23", deliveryArea: "Nungambakkam",   notes: "Low spice" },
  { id: 6,  name: "Karthik Balaji",  phone: "9500123456", email: "karthik@email.com",  plan: "Monthly", type: "Veg",     persons: 2, amount: 5200,  status: "Active",  startDate: "2026-02-01", nextRenewal: "2026-04-01", deliveryArea: "Porur",          notes: "" },
  { id: 7,  name: "Meena Suresh",    phone: "9791034512", email: "meena@email.com",    plan: "Weekly",  type: "Non-Veg", persons: 3, amount: 4200,  status: "Paused",  startDate: "2026-01-05", nextRenewal: "2026-04-10", deliveryArea: "Chromepet",      notes: "Paused for travel" },
  { id: 8,  name: "Vikram Iyer",     phone: "9840567890", email: "vikram@email.com",   plan: "Monthly", type: "Veg",     persons: 5, amount: 11500, status: "Active",  startDate: "2026-01-01", nextRenewal: "2026-04-01", deliveryArea: "Mylapore",        notes: "Extra rice" },
  { id: 9,  name: "Anitha Devi",     phone: "9677012398", email: "anitha@email.com",   plan: "Weekly",  type: "Vegan",   persons: 1, amount: 1600,  status: "Active",  startDate: "2026-02-14", nextRenewal: "2026-03-21", deliveryArea: "Sholinganallur", notes: "" },
  { id: 10, name: "Suresh Pandian",  phone: "9445098712", email: "suresh@email.com",   plan: "Monthly", type: "Non-Veg", persons: 2, amount: 4800,  status: "Active",  startDate: "2026-03-01", nextRenewal: "2026-04-01", deliveryArea: "Ambattur",       notes: "" },
];

export const AREAS = ["Anna Nagar", "T Nagar", "Velachery", "Adyar", "Nungambakkam", "Porur", "Chromepet", "Mylapore", "Sholinganallur", "Ambattur"];

export const STATUS_STYLE = {
  Active:  { bg: "#EAF3DE", color: "#27500A" },
  Pending: { bg: "#FAEEDA", color: "#633806" },
  Overdue: { bg: "#FCEBEB", color: "#791F1F" },
  Paused:  { bg: "#E6F1FB", color: "#0C447C" },
};

export const DELIVERY_STATUS_STYLE = {
  Delivered:   { bg: "#EAF3DE", color: "#27500A" },
  "Out for Delivery": { bg: "#E6F1FB", color: "#0C447C" },
  Pending:     { bg: "#FAEEDA", color: "#633806" },
  Failed:      { bg: "#FCEBEB", color: "#791F1F" },
  Skipped:     { bg: "#F1EFE8", color: "#5F5E5A" },
};

export const TYPE_COLORS = {
  Veg:       "#1D9E75",
  "Non-Veg": "#D85A30",
  Vegan:     "#534AB7",
  Jain:      "#BA7517",
};

export const AVATAR_PALETTES = [
  { bg: "#E1F5EE", color: "#085041" },
  { bg: "#EEEDFE", color: "#3C3489" },
  { bg: "#FAECE7", color: "#712B13" },
  { bg: "#E6F1FB", color: "#0C447C" },
  { bg: "#FAEEDA", color: "#633806" },
  { bg: "#EAF3DE", color: "#27500A" },
];

// ── Helpers ───────────────────────────────────────────────────────────────────
export const fmt          = (n) => "₹" + Number(n).toLocaleString("en-IN");
export const initials     = (name) => name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
export const avatarPalette = (id)  => AVATAR_PALETTES[id % AVATAR_PALETTES.length];

// ── Sidebar nav items (shared) ────────────────────────────────────────────────
export const NAV_ITEMS = [
  { label: "Dashboard",   icon: "▦", key: "dashboard"   },
  { label: "Subscribers", icon: "◎", key: "subscribers" },
  { label: "Deliveries",  icon: "◉", key: "deliveries"  },
  { label: "Leads",       icon: "◈", key: "leads"       },
  { label: "Marketplace", icon: "🛒", key: "settings"   },
  { label: "Billing",     icon: "◆", key: "billing"     },
  { label: "Orders",      icon: "◈", key: "orders"      },
  { label: "Menu",        icon: "◇", key: "menu"        },
];
